import React, { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Book", href: "#book" },
  { label: "Reviews", href: "#reviews" },
  { label: "Area", href: "#area" },
  { label: "FAQ", href: "#faq" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 backdrop-blur-xl transition-all ${
        scrolled ? "bg-white/85 border-b border-slate-200" : "bg-white/60 border-b border-transparent"
      }`}
    >
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <a href="#top" data-testid="brand-logo" className="flex items-center gap-3">
            <div className="h-9 w-9 bg-blue-600 grid place-items-center text-white font-display font-black">
              SO
            </div>
            <div className="leading-none">
              <div className="font-display font-black text-lg tracking-tight">Southern Oregon</div>
              <div className="text-[11px] tracking-[0.25em] uppercase text-blue-600 font-semibold">
                Detailing
              </div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                data-testid={`nav-link-${n.label.toLowerCase()}`}
                className="text-sm font-semibold text-slate-700 hover:text-blue-600 transition-colors tracking-wide"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="tel:5416222960"
              data-testid="header-call-button"
              className="hidden sm:inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 px-5 py-3 text-white text-sm font-bold transition-all hover:-translate-y-0.5 shadow-md"
            >
              <Phone size={16} strokeWidth={2.5} />
              541-622-2960
            </a>
            <button
              data-testid="mobile-menu-toggle"
              className="lg:hidden p-2 border border-slate-300"
              onClick={() => setOpen((v) => !v)}
              aria-label="Toggle menu"
            >
              {open ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden pb-6 grid gap-1" data-testid="mobile-nav">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="py-3 px-2 text-sm font-semibold text-slate-700 hover:bg-slate-50 border-b border-slate-100"
              >
                {n.label}
              </a>
            ))}
            <a
              href="tel:5416222960"
              className="mt-3 inline-flex items-center gap-2 bg-blue-600 px-5 py-3 text-white text-sm font-bold justify-center"
            >
              <Phone size={16} /> 541-622-2960
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
